import { FilterSetController } from '@weezevent/nacre';
import React from 'react';
import PropTypes from 'prop-types';

import { compareFilters } from 'hooks/useQueryParams/utils';

const CustomFilterSetController = ({ children, initialValues, search, ...rest }) => {
    const [forceRerenderToggle, setForceRerenderToggle] = React.useState(true);
    const prevInitialValuesRef = React.useRef(initialValues);
    const prevSearch = React.useRef(search.value || '');

    React.useEffect(() => {
        if (!prevInitialValuesRef.current) {
            return;
        }
        if (!compareFilters(prevInitialValuesRef.current, initialValues)) {
            setForceRerenderToggle(prev => !prev);
        } else if (prevSearch.current !== '' && !search.value) {
            setForceRerenderToggle(prev => !prev);
        }
        prevInitialValuesRef.current = initialValues;
        prevSearch.current = search.value || '';
    }, [initialValues, search.value]);

    return (
        <FilterSetController key={forceRerenderToggle} initialValues={initialValues} search={search} {...rest}>
            {children}
        </FilterSetController>
    );
};

CustomFilterSetController.propTypes = {
    children: PropTypes.node,
    initialValues: PropTypes.object.isRequired,
    search: PropTypes.object.isRequired,
    rest: PropTypes.object
};

CustomFilterSetController.defaultProps = {
    initialValues: {},
    search: {},
    rest: {}
};

export default CustomFilterSetController;
